//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import contentSourceBadgeAvatarTemplate from '@legacy-components/common/content-source-badge/content-source-badge-avatar.html';

(function() {
  angular.module('curalate').component('contentSourceBadgeAvatar', {
    template: contentSourceBadgeAvatarTemplate,
    bindings: {
      avatarUrl: '<',
      sourceIcon: '<',
      emailHash: '<',
      titleFirstLetter: '<',
      sourceType: '<',
    },
    controller: [
      'ContentSourceTypes',
      function(
                ContentSourceTypes,
            ) {
        const self = this;

        self.SOURCE_TYPE_UPLOAD = ContentSourceTypes.UPLOAD;
      },
    ],
  });
})();
